import { useState } from "react";
import { useNavigate } from "react-router";
import { apiFetch, ApiError } from "@/lib/api";
import { saveTokens } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface LoginResponse {
  accessToken: string | null; accessTokenExpiresUtc: string | null;
  refreshToken: string | null; refreshTokenExpiresUtc: string | null;
  mfaChallengeToken: string | null;
}

export function LoginPage() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      const res = await apiFetch<LoginResponse>("/api/auth/login", {
        method: "POST", body: JSON.stringify({ email, password }),
      });
      if (res.mfaChallengeToken) {
        void nav(`/login/mfa?challenge=${encodeURIComponent(res.mfaChallengeToken)}`);
        return;
      }
      saveTokens({
        accessToken: res.accessToken!, accessExpiresUtc: res.accessTokenExpiresUtc!,
        refreshToken: res.refreshToken!, refreshExpiresUtc: res.refreshTokenExpiresUtc!,
      });
      void nav("/");
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "Sign-in failed");
    } finally { setBusy(false); }
  }

  return (
    <div className="mx-auto mt-24 max-w-sm space-y-4">
      <h1 className="text-2xl font-semibold">Sign in</h1>
      <form onSubmit={(e) => void submit(e)} className="space-y-3" noValidate>
        <div><Label htmlFor="email">Email</Label><Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></div>
        <div><Label htmlFor="password">Password</Label><Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required /></div>
        {error && <p role="alert" className="text-sm text-destructive">{error}</p>}
        <Button type="submit" disabled={busy}>{busy ? "Signing in…" : "Sign in"}</Button>
      </form>
      <a href="/login/forgot" className="text-sm underline">Forgot password?</a>
    </div>
  );
}
